import _ from "underscore";
import LocalStorageCollection from "../prototypes/LocalStorageCollection";
import NewsModel from "./NewsModel";

//
// Collection News
//

class NewsCollection extends LocalStorageCollection<NewsModel> {
  name = "NewsCollection";
  route = "apiNewsCollection";
  model = NewsModel;
  initialize(
    models?: Record<string, any>[] | NewsModel[],
    options?: any
  ): void {
    const collection = this;
    super.initialize.apply(collection, [models, options]);
    //
  }
  filterByFlag(flag: any) {
    const collection = this,
      isAllNews = flag.isAllNews();
    let filtred: NewsModel[] = [];

    _(flag.get("news")).each((id_news) => {
      var news = collection.get(id_news);
      if (news && news.isNews()) filtred.push(news);
    });
    if (isAllNews) {
      // on ajoute les news en fin si elles n'ont pas été flagé "toutes les news"
      collection.each((news) => {
        if (news.isNews() && !flag.contains(news.id + "")) {
          filtred.push(news);
        }
      });
    }

    return new NewsCollection(filtred);
  }
}

NewsCollection.prototype.model = NewsModel;
NewsCollection.prototype.url = () => "/news/";

export default NewsCollection;
